import { Spacing } from 'zens-storybook'
import { StyleSheet, View } from 'react-native'
import { AccessType } from 'zens-store'
import { Suspense } from 'react'
import { useNumberParams } from 'zens-router'
import { BuildingInfo, FloorGrid, BuildingHeader, LayoutHeader } from '@dms/component'
import { usePermissions } from '@dms/hook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    margin: Spacing.L,
  },
  floors: {
    marginTop: Spacing.XL,
  },
})

const BuildingDetail = () => {
  const [{ companyId, locationId, buildingId }] = useNumberParams()
  const { hasPermission } = usePermissions(companyId)

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <BuildingHeader companyId={companyId} locationId={locationId} buildingId={buildingId} />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<BuildingInfo.Skeleton />}>
          <BuildingInfo companyId={companyId} locationId={locationId} buildingId={buildingId} />
        </Suspense>
        {hasPermission(AccessType.Read, 'floor') && (
          <Suspense fallback={<FloorGrid.Skeleton style={styles.floors} />}>
            <FloorGrid style={styles.floors} companyId={companyId} locationId={locationId} buildingId={buildingId} />
          </Suspense>
        )}
      </View>
    </View>
  )
}

export default BuildingDetail
